import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { ColdEmailHeroSection } from "@/components/insights/cold-email/ColdEmailHeroSection";
import { ColdEmailTakeaway } from "@/components/insights/cold-email/ColdEmailTakeaway";
import { ColdEmailFounderQuote } from "@/components/insights/cold-email/ColdEmailFounderQuote";
import { ColdEmailKeyFindings } from "@/components/insights/cold-email/ColdEmailKeyFindings";
import { ColdEmailMetrics } from "@/components/insights/cold-email/ColdEmailMetrics";
import { ColdEmailBestPractices } from "@/components/insights/cold-email/ColdEmailBestPractices";
import { InsightSEO } from "@/hooks/useInsightSEO";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const ColdEmailDeliverability = () => {
  return (
    <>
      <InsightSEO 
        slug="cold-email-deliverability" 
        additionalKeywords={["cold outreach", "email outreach", "B2B email", "sales email", "inbox placement"]}
      />
      <InsightEngagementTracker slug="cold-email-deliverability" title="Cold Email Deliverability" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="Cold Outreach" 
          currentPage="Cold Email Deliverability" 
        />
        <ColdEmailHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <ColdEmailTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <ColdEmailFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <ColdEmailKeyFindings />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <ColdEmailMetrics />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <ColdEmailBestPractices />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="cold-email-deliverability" />
        </AnimatedSection>
        
        {/* FAQ Section */}
        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="cold-email-deliverability" />
        </AnimatedSection>
        
        {/* Related Tools Section */}
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="cold-email-deliverability" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default ColdEmailDeliverability;
